import React, { createContext, useContext, useState } from "react"
import { Noop } from "../../types/noop"
export type SidebarTab = "categories" | "search" | false

type UiInitialState = {
  sidebarTab: SidebarTab
  isShowProgress: boolean
  isEditingNewMarker: boolean
  setSidebarTab: Noop
  setIsShowProgress: Noop
  setIsEditingNewMarker: Noop
}

export const UiContext = createContext<UiInitialState>({} as unknown as UiInitialState)

export const useUi = () => useContext(UiContext)

export const UiProvider = ({ children }: any) => {
  const [sidebarTab, setSidebarTab] = useState<SidebarTab>(false)
  const [isShowProgress, setIsShowProgress] = useState(false)
  const [isEditingNewMarker, setIsEditingNewMarker] = useState<boolean>(false)

  return (
    <UiContext.Provider
      value={{
        sidebarTab,
        setSidebarTab,
        isShowProgress,
        setIsShowProgress,
        isEditingNewMarker,
        setIsEditingNewMarker,
      }}
    >
      {children}
    </UiContext.Provider>
  )
}
